import { View } from 'react-native'
import DateTime from '@ui/elements/DateTime'
import { getErpDate } from '@ca/common/types'
import { getPrescriptionType, PrescriptionResponse } from '@ca/common'
import Typography from '@ui/typography/Typography'
import PrescriptionTypeBadge from '@order/PrescriptionTypeBadge'

interface Props {
  data: PrescriptionResponse
  children?: React.ReactNode
}

export default function PrescriptionHead({ data, children }: Props) {
  const createdAt = getErpDate(data.create_date)
  const prescriptionType = getPrescriptionType(data.name)

  return (
    <View className="flex h-24 flex-row items-center justify-between px-8">
      <View className="flex flex-row items-center justify-start gap-4">
        {children}
        <View className="flex flex-row items-center justify-start gap-4">
          <Typography variant="MDB">
            <DateTime
              date={createdAt}
              options={{
                dateStyle: 'medium',
                timeStyle: 'short',
              }}
            />
          </Typography>
          <PrescriptionTypeBadge type={prescriptionType} />
        </View>
      </View>
      <View className="flex flex-col">
        <Typography variant="MD" className="color-text/25 font-text-semibold">
          {data.optometrist_name}
        </Typography>
      </View>
    </View>
  )
}
